import React from 'react'
import { Badge, Container, Image } from '@pdrj/pmi-iqos-ds-react'

const SpotsBusinessBadge = ({
  spot,
  businessTypes,
  imageWidth = '12',
  filters = []
}) => {
  const getSpotBusinessBadge = () => {
    const iconDefault =
      businessTypes &&
      businessTypes.find(element => element.id === '101').iconBadge
    const spotBusinessType =
      businessTypes &&
      businessTypes.find(
        element => parseInt(element.id, 10) === spot.businessType
      )
    return spotBusinessType ? spotBusinessType.iconBadge : iconDefault
  }

  const getSpotBusinessName = filters => {
    const defaultBusinessTypeName =
      filters && filters.find(filter => filter.id === '101').name
    const businessTypeName =
      filters &&
      filters.find(
        filter => filter.id.toString() === spot.businessType.toString()
      )

    return businessTypeName ? businessTypeName.name : defaultBusinessTypeName
  }

  return (
    <Container
      display={Container.displays.flex}
      justifyContent={Container.justifyContentValues.center}
      width={imageWidth}>
      {filters && filters.length ? (
        <Badge
          text={getSpotBusinessName(filters)}
          defaultBg={Badge.defaultBackgrounds.colorContext}
        />
      ) : (
        <Image src={getSpotBusinessBadge()} />
      )}
    </Container>
  )
}

export default SpotsBusinessBadge
